import { render } from "./OidoFontSelector.vue?vue&type=template&id=29d747cd&scoped=true"
import script from "./OidoFontSelector.vue?vue&type=script&lang=js"
export * from "./OidoFontSelector.vue?vue&type=script&lang=js"

import "./OidoFontSelector.vue?vue&type=style&index=0&id=29d747cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d747cd"]])

export default __exports__